import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';
import ProductPlaceholderPNG from '@assets/png/product.png';

import { ITooltip } from '@components/Tooltip';

import { IEquipment } from '@models/Equipment.model';
import {
  Overlay,
  Container,
  Header,
  Title,
  TitleText,
  CloseButton,
  Span,
  ProductInfoContainer,
  ImagePlaceHolder,
  ProductImage,
  ProductInfoSection,
  ProductName,
  ProductInfo,
  ProductParagraph,
  ProductActions,
  ActionButton,
  ProductToolTip,
  ProductNameContainer,
  ModelEmpty,
  ProductNameEmpty,
} from './ProductDialog.styles';

interface ProductDialogProps {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  onDetails: () => void;
  amount: number;
  equipments: IEquipment[];
}

export const ProductDialog = ({
  open,
  onClose,
  onReset,
  onDetails,
  amount,
  equipments,
}: ProductDialogProps) => {
  const portalDiv = document.getElementById('portal');

  const { product } = equipments[0];

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>
                <BlueIcon icon="tick-circle" color="#52BD94" />
                <TitleText>Beam On!</TitleText>
              </Title>
              <CloseButton onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </Header>
            <ProductParagraph weight={500} margin="1rem 0 0 0">
              You’ve just added{' '}
              <Span>{amount > 1 ? `${amount} new Assets` : 'a new Asset'}</Span>
            </ProductParagraph>

            <ProductInfoContainer>
              <ImagePlaceHolder>
                <ProductImage
                  src={product.imageUrl || ProductPlaceholderPNG}
                  brokenSrc={ProductPlaceholderPNG}
                />
              </ImagePlaceHolder>
              <ProductInfoSection>
                <ProductNameContainer>
                  {product.name ? (
                    <ProductName>{product.name}</ProductName>
                  ) : (
                    <ProductNameEmpty>Empty</ProductNameEmpty>
                  )}

                  {product.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogNameTooltipId"
                      data-tip="Product Name Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogNameTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Product
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductNameContainer>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Model:
                  </ProductParagraph>
                  {product.model ? (
                    <ProductParagraph size="12px" lineHeight={18}>
                      {product.model}
                    </ProductParagraph>
                  ) : (
                    <ModelEmpty>Empty</ModelEmpty>
                  )}
                </ProductInfo>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Manufacturer:
                  </ProductParagraph>
                  <ProductParagraph size="12px" lineHeight={18}>
                    {product.manufacturer?.name}
                  </ProductParagraph>

                  {product.manufacturer.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogManufacturerTooltipId"
                      data-tip="Manufacturer Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogManufacturerTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Manufacturer
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductInfo>
              </ProductInfoSection>
            </ProductInfoContainer>

            <ProductParagraph>
              Use mass edit on the inventory page to add additional asset
              details.
            </ProductParagraph>

            <ProductActions>
              <ActionButton data-neutral onClick={onDetails}>
                Add Details
              </ActionButton>
              <ActionButton data-blue onClick={onReset}>
                Add Another Product
              </ActionButton>
            </ProductActions>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
